import { useBonuses, useAuth } from 'react-render-hooks';
import cln from 'classnames';
import { AuthInfo } from 'react-memory-optimization/dist/lib/store/user/types';
import { BonusesResponse } from 'react-memory-optimization/dist/lib/store/operations/types';
import {
  DrawerButton,
  BonusGiftSvg,
  useZustandModalKitStore,
  EModalTypes,
  zustandModalKitSelector,
} from 'react-gldn-kit';

import { useZustandCasinoDrawerStore } from 'stores/drawers/casino/store';
import { isFullCasinoDrawerSelector } from 'stores/drawers/casino/selectors';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './BonusButtons.module.css';

const BonusButtons = () => {
  const closeDrawer = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const isAuth = useHookFabric<AuthInfo>({
    fn: useAuth,
  });

  const isFullView = useZustandCasinoDrawerStore(isFullCasinoDrawerSelector);

  const { bonusOnDeposit = [], freeSpins = [] } =
    useHookFabric<BonusesResponse>({
      fn: useBonuses,
      customProps: {
        isActive: true,
      },
    }) || {};

  const openModal =
    (t: (typeof EModalTypes)[keyof typeof EModalTypes]) => () => {
      closeDrawer(t);
    };

  const isActiveBonuses = bonusOnDeposit.length || freeSpins.length;

  return (
    <DrawerButton
      size="full"
      text="drawers.casino.bonuses"
      handleClick={openModal(isAuth ? EModalTypes.Bonuses : EModalTypes.SignIn)}
      startIcon={
        <div
          className={cln(styles.box, {
            [styles.indicator]: isActiveBonuses,
          })}
        >
          <BonusGiftSvg classes={styles.giftSvg} />
        </div>
      }
      classes={styles.marginBottom}
      isFullView={isFullView}
      centreText={!isFullView}
    />
  );
};

export default BonusButtons;
